import { useEffect } from 'react'
import { Box } from '@mui/material'
import { domain, env, key } from './core/Env'
import { Preload } from './core/loader/Preload'


export const EntryAccess = () => {
	useEffect(() => {
		const encoded = new URLSearchParams(window.location.search).get('entryaccess')
		const callbackenv = env() === "prod" ? "production" : "sandbox"
		const loginUrl = `${domain('pm').url}/biz/login?entryaccess=${encodeURIComponent(encoded || '')}&from=${key('tsa_key')}&callback=${callbackenv}&platform=business`
		// const loginUrl = `${domain('pm').url}/psl/login?entryaccess=${encodeURIComponent(encoded || '')}&from=${key('tsa_key')}&callback=${env() !== 'prod' ? 'sandbox' : env()}&platform=personal`

		if (!encoded) {
			window.location.href = loginUrl
			return
		}

		let email
		try {
			email = window.atob(encoded).trim().toLowerCase()
		} catch (e) {
			window.location.href = loginUrl
			return
		}

		const session = JSON.parse(localStorage.getItem('psl_tool_session'))
		const sessionEmail = session?.ainfo?.email?.trim?.()?.toLowerCase?.() || null

		if (sessionEmail && sessionEmail === email) {
			// Drop entryaccess so index.js mounts AuthCore, not this page again
			window.location.href = '/'
			return
		}

		window.location.href = loginUrl
	}, [])

	return (
		<Box height="100%" width="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
			<Preload />
		</Box>
	)
}
